<button [ngClass]="overrideClass">
  <svg>
    <g>
      <path
        d="M19,2h-2v0h-2V0H4v2H2v0H0V3h2v15h15V3h2V2z M4.9,0.9h9.2V2H4.9V0.9z M16.1,17.1H2.9V3H4v0h11v0h1.1V17.1z"
      />
      <rect x="6" y="5" width="1" height="10" />
      <rect x="9" y="5" width="1" height="10" />
      <rect x="12" y="5" width="1" height="10" />
    </g>
  </svg>
</button>
